import Vue from '@/index.js'

import page from '@/mixins/page'
export default new Vue({
  el: '#app',
  mixins: [page],
  data() {
    return {
      partsModalOpened: false,
      priceRequestModalOpened: false,
      oneClickModalOpened: false,
      isMobile: false,
      pageScroll200: false,
      offerPrice: 0
    }
  },
  methods: {
    openPartsModal() {
      this.partsModalOpened = true
      let yaCounterId2 = this.$store.state.langs.YACOUNTER2;
      ym(yaCounterId2, 'reachGoal', 'rassrochka_card');
      setTimeout(() => {
        this.onYaPayLoad();
      }, 1500);
    },
    closePartsModal() {
      this.partsModalOpened = false
    },
    priceRequest() {
      this.priceRequestModalOpened = true
    },
    closePriceRequest() {
      this.priceRequestModalOpened = false
    },
    supportVideoYoutubeImages() {
      const allElements = document.querySelectorAll('.video-youtube-image')
      for (const elem of allElements) {
        const src = elem.getAttribute('data-src')
        if (src) {
          elem.addEventListener('click', () => {
            const iframe = document.createElement('iframe')
            iframe.setAttribute('src', src + '?autoplay=1')
            iframe.setAttribute('frameborder', '0')
            iframe.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture')
            iframe.setAttribute('allowfullscreen', '')
            iframe.classList.add('abs')
            iframe.style.zIndex = 12
            elem.classList.add('active')
            elem.appendChild(iframe)
          })
        }
      }
    },
    onPayButtonClick(){},
    onYaPayLoad(){
      if(window.YaPay && this.offerPrice>0) {
        const splitmodal = this.$refs.splitmodal;
        if(splitmodal){splitmodal.innerHTML='';}
        const YaPay = window.YaPay;
        // Данные платежа
        const paymentData = {
          env: YaPay.PaymentEnv.Production,
          version: 4,
          currencyCode: YaPay.CurrencyCode.Rub,
          merchantId: 'c2979a14-a429-4f3c-814b-0c1818e3631d',
          totalAmount: this.offerPrice,
          availablePaymentMethods: ['SPLIT'],
        };

        YaPay.createSession(paymentData, {onPayButtonClick: this.onPayButtonClick})
            .then(function (paymentSession) {
              /*paymentSession.mountWidget(
                  document.querySelector('.split'),
                  {
                    widgetType: YaPay.WidgetType.Simple,
                    widgetTheme: YaPay.WidgetTheme.Light,
                    borderRadius: 8,
                  }
              );*/
              paymentSession.mountWidget(
                  document.querySelector('.yaSplitModalViews'),
                  {
                    widgetType: YaPay.WidgetType.BnplPreview,
                    padding: YaPay.WidgetPaddingType.Default,
                  }
              );
            })
            .catch(function (err) {
              console.log(err);
              console.log('Не получилось создать платежную сессию.');
            });
      }
    }
  },
  mounted() {
    this.isMobile = window.innerWidth < 768
    setTimeout(() => {
      this.supportVideoYoutubeImages()
    }, 1000);
  },
  created(){
    window.addEventListener('scroll', () => {
      if(!this.pageScroll200 && pageYOffset > 200){
        this.pageScroll200 = true;
        this.supportVideoYoutubeImages();
      }
    });
    this.$bus.$on('mainUpdatePrice', (price) => {
      this.offerPrice = price;
    });
  },
  components: {
    layoutProductFeatures: () => import('@/components/layout/product/layout-product-features'),
    layoutProductImage: () => import('@/components/layout/product/layout-product-image'),
    'layout-product-grid-photos': () => import('@/components/layout/product/layout-product-grid-photos'),
    'layout-product-scheme': () => import('@/components/layout/product/layout-product-scheme'),
    'layout-product-raiting-code': () => import('@/components/layout/product/layout-product-raiting-code'),
    'layout-product-size-choice': () => import('@/components/layout/product/layout-product-size-choice'),
    'layout-product-material-choice': () => import('@/components/layout/product/layout-product-material-choice'),
    'layout-product-items-choice': () => import('@/components/layout/product/layout-product-items-choice'),
    'layout-product-osnovanie-choice': () => import('@/components/layout/product/layout-product-osnovanie-choice'),
    'layout-product-adds': () => import('@/components/layout/product/layout-product-adds'),
    'layout-product-services': () => import('@/components/layout/product/layout-product-services'),
    'layout-product-duration': () => import('@/components/layout/product/layout-product-duration'),
    'layout-product-delivery': () => import('@/components/layout/product/layout-product-delivery'),
    'layout-product-text-about': () => import('@/components/layout/product/layout-product-text-about'),
    'layout-product-simple-features': () => import('@/components/layout/product/layout-product-simple-features'),
    'layout-product-tabs': () => import('@/components/layout/product/layout-product-tabs'),
    'layout-product-tab': () => import('@/components/layout/product/layout-product-tab'),
    'layout-product-question': () => import('@/components/layout/product/layout-product-question'),
    'layout-product-testimonials': () => import('@/components/layout/product/layout-product-testimonials'),
    'ui-testimonial-card': () => import('@/components/ui/ui-testimonial-card'),
    'layout-product-help': () => import('@/components/layout/product/layout-product-help'),
    'ui-pretty-card': () => import('@/components/ui/ui-pretty-card'),
    'layout-product-more': () => import('@/components/layout/product/layout-product-more'),
    'layout-products-cached': () => import('@/components/layout/product/layout-products-cached'),
    'layout-product-chars': () => import('@/components/layout/product/layout-product-chars'),
    'layout-product-certificate': () => import('@/components/layout/product/layout-product-certificate'),
    'layout-product-available': () => import('@/components/layout/product/layout-product-available'),
    'layout-product-places': () => import('@/components/layout/product/layout-product-places'),
    'layout-testimonial-card': () => import('@/components/layout/testimonial/layout-testimonial-card'),
    'layout-product-layers': () => import('@/components/layout/product/layout-product-layers'),
    'layout-product-set-size-choice': () => import('@/components/layout/product/layout-product-set-size-choice'),
    'layout-product-set-material-choice': () => import('@/components/layout/product/layout-product-set-material-choice'),
    'layout-product-set-items-choice': () => import('@/components/layout/product/layout-product-set-items-choice'),
    'icon-comment': () => import('@/components/icon/icon-comment'),
    'icon-arrow-share': () => import('@/components/icon/icon-arrow-share'),
    'layout-product-modal-parts': () => import('@/components/layout/product/layout-product-modal-parts'),
    'layout-product-3d': () => import('@/components/layout/product/layout-product-3d'),
    'layout-product-carousel': () => import('@/components/layout/product/layout-product-carousel'),
    'layout-product-chart': () => import('@/components/layout/product/layout-product-chart'),
    'layout-product-image-mobile-collection': () =>
        import('@/components/layout/product/layout-product-image-mobile-collection'),
    'layout-product-description': () => import('@/components/layout/product/layout-product-description'),
    'icon-cart': () => import('@/components/icon/icon-bag'),
    'icon-arrow-right': () => import('@/components/icon/icon-arrow-right'),
    'ui-tooltip': () => import('@/components/ui/ui-tooltip'),
    'ui-tooltip-form': () => import('@/components/ui/ui-tooltip-form'),
    'layout-product-buttons-oneclick': () => import('@/components/layout/product/layout-product-buttons-oneclick'),
    'layout-product-size-beds': () => import('@/components/layout/product/layout-product-size-beds'),
  }
})
